import { tns } from './../../node_modules/tiny-slider/src/tiny-slider'

const directive = {
  bind(containerElement, binding) {
    setTimeout(() => {
      const settings = binding.value && binding.value.settings

      const defaultSettings = {
        container: '#' + containerElement.id,
        mouseDrag: true,
        loop: false,
        items: 1,
        swipeAngle: 45,
        controls: false,
        speed: 180,
        navAsThumbnails: true,
        navContainer: '#slider-thumbs',
        adaptiveHeight: true
      }

      const sliderOptions = settings || defaultSettings

      const slider = tns(sliderOptions)

      slider.events.on('indexChanged', () => {
        const indexChanged = new CustomEvent('index-changed')
        containerElement.dispatchEvent(indexChanged)
      })

      const buttonIdentifier = (binding.value && binding.value.id) ? binding.value.id : ''
      const spacer = buttonIdentifier ? '-' : ''

      const prevButton = document.querySelector(`.js-prev-slide${spacer}${buttonIdentifier}`)
      const nextButton = document.querySelector(`.js-next-slide${spacer}${buttonIdentifier}`)

      if(prevButton && nextButton) {
        prevButton.addEventListener('click', function() {
          const { displayIndex, pages } = slider.getInfo()
          if(displayIndex === 1) {
            slider.goTo(pages)
          } else {
            slider.goTo('prev')
          }
        })

        nextButton.addEventListener('click', function() {
          const { displayIndex, pages } = slider.getInfo()
          if(displayIndex === pages) {
            slider.goTo(0)
          } else {
            slider.goTo('next')
          }
        })
      }
    }, 10)
  }
}

export default directive
